<template>
  <CenteredContainer class="mt-3 hidden">
    <div
      class="relative max-w-xl mx-auto bg-white rounded sm:px-6 lg:px-8 py-16 px-4 shadow "
    >
      <div class="text-center">
        <h2
          class="text-3xl leading-9 font-semibold font-open-sans tracking-wider text-darkBlue sm:text-4xl sm:leading-10
"
        >
          Login
        </h2>
        <div class="mt-4 text-lg leading-6 text-gray-600">
          Enter an email address and we will generate a login link
        </div>
      </div>
      <div v-if="showSpinner === false" class="mt-12">
        <form v-on:submit.prevent="generateLoginLink" method="POST">
          <div>
            <label
              for="email"
              class="block text-sm font-medium leading-5 text-gray-700"
              >Email Address for User</label
            >
            <div class="mt-1 relative rounded-md shadow-sm">
              <input
                v-model="email"
                id="email"
                type="email"
                class="form-input py-3 px-4 block w-full transition ease-in-out duration-150"
              />
            </div>
          </div>
          <div class="mt-6">
            <span class="w-full inline-flex rounded-md shadow">
              <button type="submit" class="w-full standard-btn">
                Generate Link
              </button>
            </span>
          </div>
        </form>
        <div v-if="link">
          <div class="border font-mono mt-6 break-all p-2 bg-gray-50">
            {{ link }}
          </div>
          <button
            @click="copy"
            type="submit"
            class="w-full inline-flex items-center justify-center px-6 py-3 border border-transparent text-base leading-6 font-medium rounded-md text-white
                font-open-sans text-xl tracking-wider
                  bg-lightblue hover:bg-pink focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition ease-in-out duration-150"
          >
            Copy
          </button>
        </div>
        <div
          class="mt-2 text-lg font-semibold text-center text-green"
          v-if="copied"
        >
          Copied!
        </div>
      </div>
      <div v-if="showSpinner" class="mt-12">
        <submission-spinner />
      </div>
    </div>
  </CenteredContainer>
</template>

<script>
window.location.href = "/";
import CenteredContainer from "../components/CenteredContainer";
import { generateLink } from "../utils/functions";

export default {
  name: "AdminLogin",
  components: { CenteredContainer },
  data() {
    return {
      showSpinner: false,
      email: "",
      link: false,
      copied: false
    };
  },
  methods: {
    generateLoginLink() {
      generateLink(this.email).then(res => {
        this.link = res.data.signInUrl;
      });
    },
    copy() {
      navigator.clipboard.writeText(this.link).then(res => {
        this.copied = true;
        setTimeout(() => {
          this.copied = false;
        }, 2000);
      });
    }
  }
};
</script>

<style scoped></style>
